import React from 'react';

export const Muted: React.FC = () => (
  <svg width='24' height='25' fill='none' viewBox='0 0 24 25'>
    <path
      fill='red'
      d='M16.422 12.261c.352.002.642.29.594.64a4.903 4.903 0 01-.64 1.816l-.922-.922c.122-.28.214-.58.268-.896.06-.35.344-.64.7-.638zm-2.378.124L9.552 7.893c0-1.273.906-2.393 2.242-2.393a2.253 2.253 0 012.25 2.25v4.635zm4.02 5.938a.676.676 0 11-.956.956l-2.666-2.666a5.349 5.349 0 01-1.913.675v1.71a.75.75 0 11-1.5 0V17.28c-2.253-.336-4.153-2.139-4.457-4.404-.047-.349.243-.636.595-.636s.631.288.69.635c.317 1.906 2.046 3.19 3.915 3.19a4.2 4.2 0 001.733-.388l-1.245-1.245-.495.053a2.252 2.252 0 01-2.25-2.25l-.008-.54-4.03-4.031a.676.676 0 01.956-.957l11.63 11.616z'
    ></path>
  </svg>
);
